import React, { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
  bullets?: string[];
  footer?: string;
}

export const FAQItem: React.FC<FAQItemProps> = ({ question, answer, bullets, footer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}>
      <button className="faq-question" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen}>
        <span>{question}</span>
        <span className="faq-icon">{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && (
        <div className="faq-answer">
          <p>{answer}</p>
          {bullets && (
            <ul className="faq-bullets">
              {bullets.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
          {footer && <p className="faq-footer">{footer}</p>}
        </div>
      )}
    </div>
  );
};
